import {Stack, TextField, Typography} from "@mui/material";
import CountrySelect from "../../../components/formValidation/CustomCountrySelect";


const CompanyBilling = ({ data, errors }) => {

    return (
            <Stack spacing={1}>
                <Typography id="billing-name-label" variant="caption" color='primary.main'>
                    Számlázási név*
                </Typography>
                <TextField
                    defaultValue={data?.name}
                    error={!!errors.name}
                    helperText={errors.name}
                    name="name"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-name-label",
                        "aria-required": "true",
                    }}
                />

                <Typography id="billing-country-label" variant="caption" color='primary.main'>
                    Ország*
                </Typography>
                <CountrySelect
                    defaultValue={data?.country}
                    errors={!!errors.country}
                    helperText={errors.country}
                    name="country"
                    label="Ország"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-country-label",
                        "aria-required": "true",
                    }}
                />

                <Typography id="billing-state-label" variant="caption" color='primary.main'>
                    Megye*
                </Typography>
                <TextField
                    defaultValue={data?.state}
                    error={!!errors.state}
                    helperText={errors.state}
                    name="state"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-state-label",
                        "aria-required": "true",
                    }}
                />

                <Stack direction={{xs: 'column', md: 'row'}} width='100%' spacing={2}>
                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-postal-code-label" variant="caption" color='primary.main'>
                            Irányítószám*
                        </Typography>
                        <TextField
                            defaultValue={data?.zip}
                            error={!!errors.zip}
                            helperText={errors.zip}
                            name="zip"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-postal-code-label",
                                "aria-required": "true",
                            }}
                        />
                    </Stack>

                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-city-label" variant="caption" color='primary.main'>
                            Város*
                        </Typography>
                        <TextField
                            defaultValue={data?.city}
                            error={!!errors.city}
                            helperText={errors.city}
                            name="city"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-city-label",
                                "aria-required": "true",
                            }}
                        />
                    </Stack>
                </Stack>

                <Typography id="billing-address-label" variant="caption" color='primary.main'>
                    Cím*
                </Typography>
                <TextField
                    defaultValue={data?.address}
                    error={!!errors.address}
                    helperText={errors.address}
                    name="address"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-address-label",
                        "aria-required": "true",
                    }}
                />

                <Typography id="billing-vat-number-label" variant="caption" color='primary.main'>
                    Adószám*
                </Typography>
                <TextField
                    defaultValue={data?.vat_number}
                    error={!!errors.vat_number}
                    helperText={errors.vat_number}
                    name="vat_number"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-vat-number-label",
                        "aria-required": "true",
                    }}
                />
            </Stack>
    );
};

export default CompanyBilling;
